// extracted by mini-css-extract-plugin
module.exports = {"productInfoLabels":"ProductInfoLabels_productInfoLabels__fsp8R"};